export default __webpack_public_path__ + "static/media/billbee.33681f5f.svg";